let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dxWaS")).then(() => parcelRequire('6kq3q'));